import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import shouldForwardProp from "@styled-system/should-forward-prop";
import React, { useCallback, useState } from "react";
import {
  compose,
  space,
  SpaceProps,
  textAlign,
  TextAlignProps,
} from "styled-system";

import { Flex } from "~/components/blocks";
import { TermsModal } from "~/components/partials";
import { ColorPalette, MonoColor } from "~/components/styles/theme";

type Props = {
  terms?: boolean;
  policy?: boolean;
  color?: keyof typeof ColorPalette | keyof typeof MonoColor;
} & SpaceProps &
  TextAlignProps;

const Root = styled("footer", {
  shouldForwardProp,
})<Props>(
  ({ theme, color }) =>
    css({
      color: color
        ? ColorPalette[color as keyof typeof ColorPalette] ||
          MonoColor[color as keyof typeof MonoColor]
        : theme.colors.colorPallete.black,
    }),
  compose(space, textAlign),
);

const Term = styled("a")(({ theme }) =>
  css({
    display: "block",
    cursor: "pointer",
    marginRight: theme.space.m,
    "&:hover": {
      textDecoration: "underline",
    },
  }),
);

export const AppFooter = (props: Props) => {
  const { terms = true, policy = true } = props;
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);
  const handleClickTerm = useCallback(() => setIsOpen(true), []);
  const handleClickPolicy = useCallback(
    () =>
      window.open("https://www.medley.jp/external-service.html", "noopener"),
    [],
  );
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <Root {...props} pb={theme.space.xl}>
        <Flex justifyContent="center">
          {terms && (
            <small>
              <Term onClick={handleClickTerm}>利用規約</Term>
            </small>
          )}
          {policy && (
            <small>
              <Term onClick={handleClickPolicy}>外部送信ポリシー</Term>
            </small>
          )}
        </Flex>
        <small>&copy;2021 MEDLEY, INC.</small>
      </Root>
      {terms && <TermsModal open={isOpen} onClose={handleClose} />}
    </>
  );
};
